<template>
	<div class="analysisItem">
		<div class="ai-header" v-show="data.jsonData.name != '词频词汇分析'">
			<div class="ai-h-left" @click.stop="changeOpenItem(!openItem)">
				<!-- <span
					:class="['ai-h-l-icon', openItem ? 'ai-h-l-iconActive' : '']"
				></span> -->
				<span class="ai-h-l-text">{{ data.jsonData.name }}</span>
			</div>
			<div class="ai-h-right" v-if="showAdd">
				<span
					class="ai-h-r-icon4"
					@click.stop="delBtn()"
				>
					<el-tooltip
						class="item"
						effect="light"
						content="删除"
						placement="top"
					>
						<img
							:src="
								require('../../../../assets/icon/classroomObservation/del.svg')
							"
						/>
					</el-tooltip>
				</span>
			</div>
		</div>
		<div class="ai-main" v-if="openItem">
			<div class="a-m-brief">
				{{ data.jsonData.result }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	emits: ["delItem"],
	props: {
		data: {
			type: Object,
			default: () => {
				return {};
			},
		},
		index: {
			type: Number,
			default: 0,
		},
		showAdd:{
			type:Boolean,
			default:false
		},
	},
	data() {
		return {
			openItem: false,
			loading: false,
			loadNum: 0,
			userId:this.$route.query['userid'],
			showIndex: 0,
		};
	},
	computed: {

	},
	watch: {

	},
	methods: {
		changeOpenItem(newValue) {
			this.openItem = newValue;
		},

		delBtn() {
			this.$confirm("确定删除？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "error",
			}).then(() => {
				this.$emit("delItem", this.index);
			}).catch(_=>{
				console.log("取消")
			});
		},

	},
	mounted() {
	
	},
};
</script>

<style scoped>
.analysisItem {
	width: 100%;
	height: auto;
	margin: 11.7px 0px;
	padding-right: 10px;
	box-sizing: border-box;
	border: solid 1px #F0F0F0;
	border-radius: 3px;
}
.text1 {
	color: rgba(54, 129, 252, 1);
}
.text2 {
	color: rgba(23, 196, 105, 1);
}
.ai-header {
	width: 100%;
	height: 50px;
	display: flex;
	background-color: white;
	border-radius: 5px;
}
.ai-h-left {
	flex: 1;
	height: 100%;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	padding: 0 10px;
	cursor: pointer;
}

.ai-h-l-icon {
	width: 16px;
	height: 16px;
	background: url("../../../../assets/icon/classroomObservation/right.svg")
		no-repeat;
	background-size: 100% 100%;
	margin-right: 10px;
	transition: 0.3s;
}

.ai-h-l-iconActive {
	transform: rotate(90deg);
}
.ai-h-l-text {
	font-size: 18px;
}

.ai-h-right {
	width: auto;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-around;
	position: relative;
}

.ai-h-right > span {
	width: 18px;
	height: 18px;
	background-size: 100% 100%;
	margin: 0 10px;
	cursor: pointer;
}

.ai-h-right > span > img {
	width: 18px;
	height: 18px;
}

.ai-h-r-icon1 {
	background: url("../../../../assets/icon/classroomObservation/back.svg");
	/* 镜像 */
	transform: scaleX(-1);
}

.ai-h-r-icon2 {
	background: url("../../../../assets/icon/classroomObservation/back.svg");
}

.ai_h_r_iconOpacity {
	opacity: 0.5;
	cursor: not-allowed !important;
}

.ai-h-r-icon3 {
	background: url("../../../../assets/icon/classroomObservation/edit.svg");
	/* display: none; */
}

.ai-header:hover .ai-h-r-icon4 {
	display: block;
}

.ai-h-r-icon4 {
	background: url("../../../../assets/icon/classroomObservation/del.svg");
	/* position: absolute; */
	/* right: -40px; */
	display: none;
}

.analysisItem:hover .ai-h-r-icon4 {
	display: block;
}

.ai-main {
	width: 100%;
	height: auto;
	background-color: white;
	border-radius: 0 0 5px 5px;
	overflow: auto;
	box-sizing: border-box;
	padding: 10px 20px;
}

.a-m-brief {
	font-size: 16px;
	/* 斜体 */
	font-style: italic;
	margin-bottom: 10px;
	color: #6b798e;
}

td,
th {
	padding: 10px;
}

.generate{
	color: #00000099;
	font-size: 16px;
	display: flex;
	align-items: center;
}

.generate>img{
	margin-right: 5px;
	width: 20px;
	height: 20px;
}

.generateSuccess{ 
	color: #17C469;
	font-size: 16px;
	display: flex;
	align-items: center;
}

.generateSuccess>img{
	margin-right: 5px;
	width: 20px;
	height: 20px;
}

.generateError{
	color: #e60012;
	font-size: 16px;
	display: flex;
	align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/classroomObservation/components/analysisItem2.vue